/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
import React, { useContext, useState } from 'react';
import { CloseCircleOutlined } from '@ant-design/icons';
import { Col, Divider, Input, message, Row, Typography } from 'antd';
import { axiosErp } from 'shared/config/axios';
import { getStoredAuthToken } from 'shared/utils/authToken';
import { HaierCostingStatus } from 'views/Costing/common/model/haierCostingStatus.model';
import { HaierCostingContext } from 'views/Costing/common/context/HaierCostingContext';
import formatCurrency from 'shared/utils/formatCurrency';
import { Button } from 'shared/components';
import { useHistory } from 'react-router-dom';
import { StyledModal } from './Styles';

const { Text } = Typography;
const { TextArea } = Input;
type ModalConfirmRejectProps = {
  visible: boolean;
  onCancel: () => void;
};

const ModalConfirmReject: React.FC<ModalConfirmRejectProps> = (props) => {
  const { onCancel, visible } = props;
  const token = getStoredAuthToken();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [rejectRemark, setrejectRemark] = useState<string>('');
  const { selectedCostingDetail } = useContext(HaierCostingContext);
  const { modalConfirmReject, costingId, backUrl } = selectedCostingDetail;
  const { costingNumber, grandTotalPrice, grandTotalPriceSale } = modalConfirmReject;

  const closeModalHandler = () => {
    history.push(backUrl);
  };

  const confirmReject = async () => {
    setLoading(true);
    try {
      await axiosErp(token).post(`update-costing-trip-turboo`, {
        filter: { _id: costingId },
        update: { costingStatus: HaierCostingStatus.REJECT, rejectRemark },
      });
      setLoading(false);
    } catch (e) {
      message.error(e.message || 'เกิดข้อผิดพลาดในการยืนยันการตรวจสอบรายการราคา');
      console.error('ERROR TO LOAD COSTING DETAIL: ', e);
    } finally {
      message.success('เปลี่ยนสถานะต้นทุน/ขายแล้ว');
      setLoading(false);
      setTimeout(() => {
        closeModalHandler();
      }, 500);
    }
  };

  return (
    <StyledModal
      className="custom-modal"
      title="คุณต้องการปฎิเสธใช่หรือไม่?"
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Button
          key="okButton"
          icon={<CloseCircleOutlined />}
          color="red--light"
          onClick={() => confirmReject()}
          loading={loading}
          disabled={rejectRemark === ''}
        >
          ยืนยันปฎิเสธราคา
        </Button>,
        <Button
          key="cancelButton"
          icon={<CloseCircleOutlined />}
          onClick={onCancel}
          disabled={loading}
        >
          ยกเลิก
        </Button>,
      ]}
      afterClose={() => setrejectRemark('')}
    >
      <div>
        ต้องการปฎิเสธราคา <Text strong>รหัสต้นทุน/ขาย: {costingNumber}</Text>
      </div>
      <div>
        ต้นทุน <Text strong>{formatCurrency(grandTotalPrice)} บาท</Text> และ รายได้{' '}
        <Text strong>{formatCurrency(grandTotalPriceSale)} บาท</Text> ใช่หรือไม่?
      </div>

      <Divider style={{ marginTop: 10, marginBottom: 10 }} />

      <Row>
        <Col span={24}>
          เหตุผลการปฎิเสธ:<Text type="danger">*</Text>
        </Col>
        <Col span={24}>
          <TextArea
            value={rejectRemark}
            onChange={(event) => setrejectRemark(event.target.value)}
            placeholder="ระบุเหตุผล"
            rows={2}
          />
        </Col>
      </Row>
    </StyledModal>
  );
};

export default ModalConfirmReject;
